<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12">
        <v-form
          name="customerform"
          @submit.prevent=""
          v-model="customerFormValid"
        >
          <v-card class="mb-12" color="grey lighten-5">
            <v-container>
              <v-row>
                <v-col cols="12" xs="12" sm="4">
                  <v-text-field
                    label="*Kdnr"
                    name="kdnr"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="customer.kdnr"
                    required
                    dense
                    :rules="requiredRule"
                  />
                </v-col>

                <v-col cols="12" xs="12" sm="8">
                  <v-text-field
                    label="*Name"
                    name="name"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="customer.name"
                    required
                    dense
                    :rules="requiredRule"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12">
                  <v-text-field
                    label="*Adresse"
                    name="adresse"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="customer.adresse"
                    required
                    dense
                    :rules="requiredRule"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="4">
                  <v-select
                    label="*Land"
                    name="land"
                    :items="countryList"
                    item-text="nameDE"
                    item-value="code"
                    color="purple"
                    :clearable="true"
                    v-model="customer.land"
                    required
                    dense
                    :rules="requiredRule"
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="2">
                  <v-text-field
                    label="*PLZ"
                    name="plz"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="customer.plz"
                    required
                    dense
                    :rules="requiredRule"
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="6">
                  <v-text-field
                    label="*Ort"
                    name="ort"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="customer.ort"
                    required
                    dense
                    :rules="requiredRule"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="6">
                  <v-text-field
                    label="Email*"
                    name="email"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="customer.email"
                    dense
                    :rules="requiredEmailRules"
                  />
                </v-col>

                <v-col cols="12" xs="12" sm="6">
                  <v-text-field
                    label="Telefon"
                    name="telefon"
                    type="text"
                    color="purple"
                    :clearable="true"
                    v-model="customer.telefon"
                    dense
                  />
                </v-col>
              </v-row>

              <v-divider class="ma-6"></v-divider>
              <h3>Parameter</h3>
              <v-row>
                <v-col cols="12" sm="3">
                  <v-switch
                    color="green"
                    v-model="customer.exportOrders"
                    label="Bestellungen für SLA exportieren"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-switch
                    color="green"
                    v-model="customer.grossgebinde"
                    label="Großgebinde Bestellungen möglich"
                  />
                </v-col>
                <v-col cols="12" sm="3" offset-sm="1">
                  <v-switch
                    color="green"
                    v-model="customer.restekarte"
                    label="Restekarte aktivieren"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    :disabled="!customer.restekarte"
                    type="number"
                    min="0"
                    max="7"
                    v-model="customer.restekarteMaxTage"
                    label="Restekarte Max. Tage"
                    hint="Max. Alter in Tagen, der übrig gebliebenen Speisen, die angezeigt werden."
                    persistent-hint
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-label>Arbeitswochentage</v-label><br />
                  <v-chip-group multiple v-model="customer.arbeitstage">
                    <v-chip
                      filter
                      active-class="daySelected"
                      v-for="item in wochentage"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.text }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="3">
                  <v-select
                    :items="wochentage"
                    label="Bestellende Wochentag"
                    name="orderendday"
                    color="purple"
                    hint="Stichtag für das Bestellende 1 Woche davor"
                    persistent-hint
                    v-model="customer.bestellendeTag"
                  />
                </v-col>
                <v-col sm="6" offset-sm="3">
                  <MenuTimePicker
                    v-model="customer.bestellendeZeit"
                    label="Zeit Bestellende"
                  />
                </v-col>
              </v-row>

              <v-divider class="ma-6"></v-divider>
              <h3>Mahlzeiten</h3>
              <v-row>
                <v-col sm="4"> </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[0].von"
                    label="Mahlzeit 1 von"
                    required
                    :rules="requiredRule"
                  />
                </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[0].bis"
                    label="Mahlzeit 1 bis"
                    required
                    :min="customer.mahlzeiten[0].von"
                    :rules="requiredRule"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="4">
                  <v-switch
                    label="Mahzeit 2"
                    name="meal2"
                    color="success"
                    v-model="customer.mahlzeiten[1].active"
                    :disabled="!customer.mahlzeiten[0].active"
                  />
                </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[1].von"
                    label="Mahlzeit 2 von"
                    :disabled="!customer.mahlzeiten[1].active"
                  />
                </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[1].bis"
                    label="Mahlzeit 2 bis"
                    :min="customer.mahlzeiten[1].von"
                    :disabled="!customer.mahlzeiten[1].active"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="4">
                  <v-switch
                    label="Mahzeit 3"
                    name="meal3"
                    color="success"
                    v-model="customer.mahlzeiten[2].active"
                    :disabled="!customer.mahlzeiten[1].active"
                  />
                </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[2].von"
                    label="Mahlzeit 3 von"
                    :disabled="!customer.mahlzeiten[2].active"
                  />
                </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[2].bis"
                    label="Mahlzeit 3 bis"
                    :disabled="!customer.mahlzeiten[2].active"
                    :min="customer.mahlzeiten[2].von"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="4">
                  <v-switch
                    label="Mahzeit 4"
                    name="meal4"
                    color="success"
                    v-model="customer.mahlzeiten[3].active"
                    :disabled="!customer.mahlzeiten[2].active"
                  />
                </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[3].von"
                    label="Mahlzeit 4 von"
                    :disabled="!customer.mahlzeiten[3].active"
                  />
                </v-col>
                <v-col sm="4">
                  <MenuTimePicker
                    v-model="customer.mahlzeiten[3].bis"
                    label="Mahlzeit 4 bis"
                    :disabled="!customer.mahlzeiten[3].active"
                    :min="customer.mahlzeiten[3].von"
                  />
                </v-col>
              </v-row>
              <v-divider class="ma-6"></v-divider>
              <v-row>
                <h2>Branding:</h2>
              </v-row>
              <v-row>
                <v-col>
                  <v-switch
                    v-model="customer.branding.active"
                    color="green"
                    label="Branding aktivieren"
                  ></v-switch>
                </v-col>

                <v-col>
                  <v-text-field
                    label="Subdomain"
                    placeholder="subdomain.anewo.at"
                    v-model="customer.branding.hostname"
                  >
                    <template v-slot:append> .anewo.at </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4">
                  Primary:
                  <colorPicker v-model="customer.branding.theme.primary" />
                </v-col>
                <v-col cols="12" sm="4">
                  Secondary:
                  <colorPicker v-model="customer.branding.theme.secondary" />
                </v-col>
                <v-col cols="12" sm="4">
                  Accent:
                  <colorPicker v-model="customer.branding.theme.accent" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3">
                  Error: <colorPicker v-model="customer.branding.theme.error" />
                </v-col>
                <v-col cols="12" sm="3">
                  Warning:
                  <colorPicker v-model="customer.branding.theme.warning" />
                </v-col>
                <v-col cols="12" sm="3">
                  Info: <colorPicker v-model="customer.branding.theme.info" />
                </v-col>
                <v-col cols="12" sm="3">
                  Success:
                  <colorPicker v-model="customer.branding.theme.success" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <MultiUploader
                    v-if="dataReady"
                    ref="imageUploader"
                    :axiosInstance="getAxiosInstance()"
                    :multiple="false"
                    :maxFiles="1"
                    :autoUpload="false"
                    hideUploadButton
                    uploadUrl="/customer/image"
                    :existentItems="customer.branding.logo"
                    numberFormat="de-DE"
                    displayText="Drag'n drop oder klicken um Dateien hochzuladen"
                    @filesSelected="filesSelectedEvent"
                    @maxFilesReached="maxFilesReached"
                    @imageRemoved="imageRemoved"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    outlined
                    label="CSS"
                    height="475px"
                    v-model="customer.branding.css"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-divider class="ma-6"></v-divider>
              <h3>Lieferorte</h3>
              <v-row align="center">
                <v-col cols="12" sm="6">
                  <v-btn color="secondary" @click="newLieferort">
                    <v-icon>mdi-plus</v-icon> Lieferort hinzufügen</v-btn
                  >
                </v-col>
                <v-col cols="12" sm="6">
                  <v-switch
                    v-model="customer.manageLieferorte"
                    color="green"
                    label="Kunde darf Lieferorte verwalten"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Status</th>
                          <th class="text-left">Standort</th>
                          <th class="text-left">Lieferort ID</th>
                          <th class="text-left">Großgebinde</th>
                          <th class="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in customer.anlieferorte"
                          :key="item._id"
                        >
                          <td>
                            <v-chip
                              small
                              :color="item.active ? 'green' : 'red'"
                              >{{ item.active ? "Aktiv" : "Inaktiv" }}</v-chip
                            >
                          </td>
                          <td>{{ item.standort }}</td>
                          <td>{{ item._id }}</td>
                          <td>
                            <v-switch
                              :disabled="!customer.grossgebinde"
                              small
                              color="green"
                              v-model="item.grossgebinde"
                            />
                          </td>
                          <td>
                            <v-btn
                              v-print="printObjLieferort"
                              icon
                              @click="printLieferort(item)"
                              ><v-icon>mdi-printer</v-icon></v-btn
                            >
                            <v-btn icon @click="editLieferort(item)"
                              ><v-icon>mdi-pencil</v-icon></v-btn
                            >
                            <v-btn
                              icon
                              color="red"
                              @click="deleteLieferort(item)"
                              ><v-icon @click="deleteLieferort"
                                >mdi-delete</v-icon
                              ></v-btn
                            >
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-divider class="ma-6"></v-divider>
              <h3>Roboter</h3>
              <v-row>
                <v-col>
                  <v-autocomplete
                    label="Roboter"
                    name="roboter"
                    ref="roboterSelectbox"
                    multiple
                    chips
                    deletable-chips
                    clearable
                    :items="roboterList"
                    v-model="customer.roboters"
                    return-object
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-btn
                outlined
                :to="{ path: '/customers' }"
                color="error"
                type="button"
                name="cancel"
                >Abbrechen</v-btn
              >
              <v-spacer />
              <v-btn
                color="success"
                @click="save()"
                :disabled="!customerFormValid"
              >
                Speichern
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="dlgLieferort" width="500px">
      <v-toolbar dark>
        <v-toolbar-title>Lieferort bearbeiten</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dlgLieferort = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card>
        <v-card-text></v-card-text>
        <v-form name="formlieferort">
          <v-container>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" sm="6">
                <v-switch
                  color="green"
                  v-model="lieferort.active"
                  label="Lieferort aktiv"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-switch
                  color="green"
                  v-model="lieferort.grossgebinde"
                  label="Großgebinde aktiv"
                />
              </v-col>
            </v-row>
            <v-row class="pa-0 ma-0" justify-center align-center>
              <v-col cols="12" sm="12">
                <v-text-field
                  label="Lieferort ID"
                  name="lieferortId"
                  type="text"
                  color="purple"
                  v-model="lieferort._id"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" sm="12">
                <v-text-field
                  label="Lieferort Standort"
                  name="standort"
                  type="text"
                  color="purple"
                  :clearable="true"
                  v-model="lieferort.standort"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="red" @click="dlgLieferort = false"
            >Abbrechen</v-btn
          >
          <v-btn outlined color="green" @click="saveLieferort">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      v-if="printLieferortItem"
      class="d-none d-print-block"
      id="printLieferort"
    >
      <v-row>
        <v-col>
          <h2>Lieferort: {{ printLieferortItem.standort }}</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <img :src="printLieferortItem.qrCode" width="300px" />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import DataService from "@/services/DataService.js";
import MenuTimePicker from "@/components/MenuTimePicker.vue";
import colorPicker from "@/components/colorPicker.vue";
import MultiUploader from "@/components/MultiUploader.vue";
import CustomerService from "@/services/CustomerService.js";

export default {
  name: "CustomerForm",
  components: { MenuTimePicker, colorPicker, MultiUploader },
  data: () => ({
    printLieferortItem: null,
    dataReady: false,
    printObjLieferort: {
      id: "printLieferort",
      popTitle: "Lieferort",
    },
    dlgLieferort: false,
    isLieferortEdit: false,
    lieferort: {
      _id: null,
      active: true,
      standort: "",
    },

    customer: {
      _id: null,
      kdnr: "",
      name: "",
      telefon: "",
      email: "",
      adresse: "",
      plz: "",
      ort: "",
      land: "AT",
      arbeitstage: [1, 2, 3, 4, 5],
      roboters: [],
      anlieferorte: [],
      grossgebinde: false,
      restekarte: false,
      restekarteMaxTage: 4,
      manageLieferorte: false,
      exportOrders: true,
      bestellendeTag: 3,
      bestellendeZeit: "12:00",
      branding: {
        _id: null,
        hostname: "",
        logo: "",
        css: "",
        active: false,
        theme: {
          primary: "",
          secondary: "",
          accent: "",
          error: "",
          warning: "",
          info: "",
          success: "",
        },
      },
      mahlzeiten: [
        {
          active: true,
          von: "00:00",
          bis: "23:59",
        },
        {
          active: false,
          von: "",
          bis: "",
        },
        {
          active: false,
          von: "",
          bis: "",
        },
        {
          active: false,
          von: "",
          bis: "",
        },
      ],
    },
    menuZeit: false,
    wochentage: [
      { text: "Montag", value: 1 },
      { text: "Dienstag", value: 2 },
      { text: "Mittwoch", value: 3 },
      { text: "Donnerstag", value: 4 },
      { text: "Freitag", value: 5 },
      { text: "Samstag", value: 6 },
      { text: "Sonntag", value: 7 },
    ],

    requiredRule: [(value) => !!value || "Dieses Feld wird benötigt!"],
    emailRules: [
      (v) =>
        /^$/.test(v) ||
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail Format ungültig",
    ],
    requiredEmailRules: [
      (v) => !!v || "E-mail wird benötigt!",
      (v) =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail Format ungültig",
    ],

    formValid: true,
    customerFormValid: false,
  }),

  methods: {
    newLieferort() {
      this.clearLieferort();
      this.dlgLieferort = true;
      CustomerService.getLieferortID()
        .then((result) => {
          this.lieferort._id = result.data.lid;
          this.lieferort.qrCode = result.data.qrCode;
        })
        .catch((error) => {
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        });
    },
    editLieferort(item) {
      this.isLieferortEdit = true;
      this.lieferort = item;
      this.dlgLieferort = true;
    },
    deleteLieferort(item) {
      this.customer.anlieferorte = this.customer.anlieferorte.filter(
        (el) => el._id !== item._id
      );
    },
    saveLieferort() {
      if (this.isLieferortEdit) {
        const lieferort = this.lieferort;
        this.isLieferortEdit = false;
        let editItem = this.customer.anlieferorte.find(
          (el) => el._id === lieferort._id
        );
        if (editItem) {
          editItem = lieferort;
        }
      } else {
        this.customer.anlieferorte.push(this.lieferort);
      }
      this.dlgLieferort = false;
    },
    printLieferort(item) {
      this.printLieferortItem = item;
    },
    clearLieferort() {
      this.lieferort = {
        _id: null,
        active: true,
        standort: "",
        qrCode: "",
      };
    },

    save() {
      //Save customer
      CustomerService.save({
        id: this.customer._id,
        data: this.customer,
      })

        .then((result) => {
          if (
            this.$refs.imageUploader &&
            this.$refs.imageUploader.files.length > 0
          ) {
            this.$refs.imageUploader.formData = [
              {
                name: "_id",
                value: this.customer._id
                  ? this.customer._id
                  : result.data.data._id,
              },
            ];
            this.$refs.imageUploader.upload();
          }

          //if success redirecht to list
          this.$router.push({ name: "customers" });
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Kunde gespeichert",
            text: "Kunde erfolgreich gespeichert",
          });
        })
        .catch((error) => {
          //on error alert error
          console.log(error);
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        });
    },
    createMahlzeiten() {
      return [
        {
          active: true,
          von: "",
          bis: "",
        },
        {
          active: false,
          von: "",
          bis: "",
        },
        {
          active: false,
          von: "",
          bis: "",
        },
        {
          active: false,
          von: "",
          bis: "",
        },
      ];
    },
    getAxiosInstance() {
      return DataService.apiClient;
    },

    maxFilesReached() {
      this.$notify({
        group: "dataline",
        type: "warn",
        title: "Max Bilder erreicht",
        text: "Max Anzahl der Bilder erreicht",
      });
    },

    filesSelectedEvent() {},
    imageRemoved() {
      this.customer.branding.logo = null;
      CustomerService.removeLogo(this.customer._id)
        .then(() => {
          // this.customer.branding.logo = null;
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Bild entfernt",
            text: "Bild wurde entfernt",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: "Bild konnte nicht entfernt werden",
          });
        });
    },
  },
  computed: {
    countryList() {
      return this.$store.getters["countries/getCountryList"];
    },
    roboterList() {
      let items = [];
      let roboters = this.$store.getters["roboter/getRoboterList"];
      for (let robot of roboters) {
        items.push({
          text: `${robot.name} - ${robot.standort}`,
          value: robot._id,
        });
      }
      return items;
    },

    Customer: {
      get() {
        return this.customer;
      },
      set(m) {
        this.customer = m;
      },
    },
  },
  created() {
    this.$store.dispatch("roboter/fetchRoboterList");
  },
  beforeCreate() {
    const id = this.$route.params.id;

    if (id) {
      CustomerService.get(id)
        .then((item) => {
          this.customer = item.data.data;
          if (this.customer.mahlzeiten.length == 0) {
            this.customer.mahlzeiten = this.createMahlzeiten();
          }
          if (!this.customer.anlieferorte) {
            this.customer.anlieferorte = [];
          }
          if (!this.customer.exportOrders) {
            this.customer.exportOrders = true;
          }
          if (!this.customer.branding) {
            this.customer.branding = {
              _id: null,
              hostname: "",
              logo: "",
              css: "",
              active: false,
              theme: {
                primary: "",
                secondary: "",
                accent: "",
                error: "",
                warning: "",
                info: "",
                success: "",
              },
            };
          }
          if (!this.customer.branding.theme) {
            this.customer.branding.theme = {
              primary: "",
              secondary: "",
              accent: "",
              error: "",
              warning: "",
              info: "",
              success: "",
            };
          }
          if (this.customer.branding.logo) {
            this.customer.branding.logo = `${process.env.VUE_APP_API_URL}/ressources/images/${this.customer.branding.logo}`;
          }
          this.dataReady = true;
        })
        .catch((error) => {
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        });
    } else {
      this.dataReady = true;
    }
  },
};
</script>

<style scoped>
.daySelected {
  background-color: #c25443;
  color: white;
}
</style>
